import React, { FC } from 'react';
import styled from 'styled-components';

// components
import { Switcher, Switchee } from 'components/Switcher';
import SelectExistingChatroom from './sections/SelectExistingChatroom';
import ChatroomEdit from './sections/ChatroomEdit';

// constants
import { defaultValues } from '../LiveLikeChatForm';

const Padding = styled.div`
  padding: 3em;
`;

export const TwoRowGrid = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  grid-gap: 3em;
`;

export enum SwitchableState {
  SELECT_EXISTING_CHATROOM = 'select_existing_chatroom',
  EDIT_EXISTING_CHATROOM = 'edit_existing_chatroom',
  CREATE_NEW_CHATROOM = 'create_new_chatroom',
}

export interface Props {
  handleBackToWidgets: (resetForm?: () => void) => void;
}

const ChatroomField: FC<Props> = ({ handleBackToWidgets }) => (
  <Padding>
    <Switcher initialValue={SwitchableState.SELECT_EXISTING_CHATROOM}>
      <Switchee value={SwitchableState.SELECT_EXISTING_CHATROOM}>
        <SelectExistingChatroom handleBackToWidgets={handleBackToWidgets} />
      </Switchee>
      <Switchee value={SwitchableState.EDIT_EXISTING_CHATROOM}>
        <ChatroomEdit heading="Edit chat" modifiedValues={{ patch: true }} isTitleReadOnly />
      </Switchee>
      <Switchee value={SwitchableState.CREATE_NEW_CHATROOM}>
        <ChatroomEdit heading="Create new chat" modifiedValues={defaultValues} />
      </Switchee>
    </Switcher>
  </Padding>
);

export default ChatroomField;
